import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const RootRedirect: React.FC = () => {
  const { isAuthenticated, isLoading, role } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect based on authentication state and role
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If user has admin role, redirect to dashboard
  // Otherwise, redirect to restricted access page
  return role === 'admin' ? <Navigate to="/dashboard" replace /> : <Navigate to="/restricted" replace />;
};
